import React from 'react';
import { connect } from 'react-redux';
import styles from './priority-page.scss';
import PropTypes from 'prop-types';
import BubbleChart from '../../components/bubble-chart';
import * as selectors from '../../reducers';
import ClusterHeadlineAndToolTip from '../../components/cluster-headline-and-tooltip';

const priorityNameMapper = {
  Customer: 'Customer Experience',
  DOI: 'Digital On The Inside',
  Data: 'Data',
};

class PriorityPage extends React.Component {
  renderClusters() {
    const { projectsByPriority } = this.props;
    return Object.keys(projectsByPriority).map(cluster => {
      return (
        <div key={cluster} className={styles.cluster}>
          <ClusterHeadlineAndToolTip
            title={priorityNameMapper[cluster]}
            data={projectsByPriority[cluster]}
          />

          <BubbleChart
            title={cluster}
            data={projectsByPriority[cluster]}
            canvasId={'clusterWrapper'}
          />
        </div>
      );
    });
  }

  render() {
    return (
      <div className={styles.clusterWrapper} id={'clusterWrapper'}>
        {this.renderClusters()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  projectsByPriority: selectors.getProjectsByPriority(state),
  activeProject: selectors.getActiveProject(state),
});

PriorityPage.propTypes = {
  projectsByPriority: PropTypes.object,
  activeProject: PropTypes.object,
};

export default connect(mapStateToProps, null)(PriorityPage);



// WEBPACK FOOTER //
// ./src/pages/priority-page/priority-page.js